var _defs, _path, _path2, _path3, _path4, _circle, _circle2, _circle3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOem(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".body{fill:#20aaaa;}.eye-white{fill:#f5f5f5;}.eye-black{fill:#202020;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "DF_1.0") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "body",
    d: "M512,134.43A375.89,375.89,0,0,1,692,180L512,0,332,180A375.89,375.89,0,0,1,512,134.43Z",
    transform: "translate(0 0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "body",
    d: "M844,692l180-180L844,332A378.18,378.18,0,0,1,844,692Z",
    transform: "translate(0 0)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "body",
    d: "M512,889.57A375.89,375.89,0,0,1,332,844l180,180L692,844A375.89,375.89,0,0,1,512,889.57Z",
    transform: "translate(0 0)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "body",
    d: "M134.43,512A375.89,375.89,0,0,1,180,332L0,512,180,692A375.89,375.89,0,0,1,134.43,512Z",
    transform: "translate(0 0)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "body",
    cx: 512,
    cy: 512,
    r: 282.21
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "eye-white",
    cx: 512,
    cy: 512,
    r: 187.32
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "eye-black",
    cx: 532.54,
    cy: 492.35,
    r: 47.33
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOem);
export default __webpack_public_path__ + "static/media/oem.1309289636c88a558d1595e513a88169.svg";
export { ForwardRef as ReactComponent };